import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import http from '../../services/http';
import config from '../../config';

class PaymentFinished extends React.Component {
  async componentDidMount() {
    const { history } = this.props;
    const paymentToken = this.getPaymentToken();
    const paymentStatus = this.getPaymentStatus();

    try {
      await http.get(`/api/client/updatePaymentStatus?paymentToken=${paymentToken}&paymentStatus=${paymentStatus}`);
    } catch {
      //
    }

    setTimeout(() => {
      history.replace('/my-orders');
    }, 3000);
  }

  getPaymentStatus = () => {
    const { success } = this.props;
    return success ? config.paymentStatus.success : config.paymentStatus.failure;
  }

  getPaymentToken = () => {
    const { paymentToken } = queryString.parse(window.location.search);
    return paymentToken;
  }

  render() {
    const { success } = this.props;

    return (
      <div>
        <p>{success ? 'Płatność zakończona sukcesem' : 'Płatność zakończona niepowodzeniem'}</p>
        <p>Za chwilę nastąpi przekierowanie do aplikacji...</p>
      </div>
    );
  }
}

PaymentFinished.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func,
  }).isRequired,
  success: PropTypes.bool.isRequired,
};

export default withRouter(PaymentFinished);
